import { createStorageBase } from '@/core/utils/localStorage';
export const appLocalStorage = createStorageBase('local');
